import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

class FormConfiguration extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      company_id: 'string',
      export_format: 'string',
      from_date: 'date',
      to_date: 'date',
      with_files: 'boolean',
    })
    makeObservable(this, {
      mandatoryFieldsEmpty: computed,
    })
  }

  get mandatoryFieldsEmpty() {
    const mandatoryFields: string[] = ['export_format', 'from_date', 'to_date']

    return mandatoryFields.some((field: string) => {
      return !this.get(field).value
    })
  }
}

export default FormConfiguration
